import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment'; 
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, LinearProgress, Paper, TextField, Tooltip, Typography} from '@mui/material';
import { NumericFormat } from 'react-number-format';
import CurrencyTextField from '../ui/CurrencyTextField';

import AccountLedgerSummaryFetch from '../account/AccountLedgerSummaryFetch';
import AccountSpendingThisMonthFetch from '../account/AccountSpendingThisMonthFetch';
import HelpOutline from '@mui/icons-material/HelpOutline';

import DashboardRequestLimitDialog from './DashboardRequestLimitDialog';


const abEnvironment = new AbEnvironment();
const DashboardLimitRequestQuery = graphql`
query DashboardLimitRequestQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    maxCharge
    floatLimit
    maxMonthlyBudget
  }
}
`;

const styleSheet = theme => ({
  root: {
      width: '100%',
  },
  rootLoggedIn: {
      flexGrow: 1,
      padding: 20,
  },
  button: {
    paddingLeft: 8,
  },
  buttonout: {
    paddingLeft: 8,
    marginBottom: 12,
  },
  buttonicon: {
    marginRight: 6,
  },
  instructButton: {
    marginTop: -1,
    marginLeft: 3,
    marginRight: 3,
  },
  instructText: {
    marginTop: 8,
    // marginLeft: -11,
  },
  paper: {
      marginTop: 32,
      paddingTop: 16,
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: 20,
      color: theme.palette.text.secondary,
  },
  dbTile: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 68,
    width: 212
  },
  dbTile2: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 68,
    width: 184
  },
  lp1: {
    height: 12,
    width: 204
  },
  lp2: {
    height: 12,
    width: 176
  },
  theTitle: {
      marginTop: 4,
      marginBottom: 15,
  },
  section: {
      marginTop: 12,
      display: 'flex',
      flexWrap: 'wrap',
  },
  gridItem: {
    minWidth: 120,
  },
  sectionHeader: {
      marginTop: 16,
      // marginBottom: 15
  },
  tileWrapper: {
    minWidth: 240,
    marginTop: 16,
    marginLeft: 12,
    marginRight: 12,
    //padding: 12,
  },
  iconp: {
      marginTop: 12
  },
  appnameitem: {
    marginLeft: 8,
  },
  rtable: {
    marginTop: 16,
  },
  moretext: {
    height: 30,
    width: 172,
    paddingTop: 26,
    paddingBottom: 16,
    paddingLeft: 28,
  },
  appgrid: {
    minWidth: 136,
  },
  custlink: {
    marginTop: 4,
    marginBottom: 4,
  },
  tblHead: {
    backgroundColor: '#f1f1f1',
  },
  tblHeadRow: {
    height: 24,
  },
  tblHeadCell: {
    textAlign: 'left',
    verticalAlign: 'bottom',
    borderBottom: 0,
  },
  tblSumCell: {
    textAlign: 'left'
  },
  tblSumTxt: {
    marginTop: 8,
    marginBottom: 8,
    fontWeight: 'bold'
  }
});

  
class DashboardLimitRequest extends Component {
    
  constructor(props) {
    super(props);

    this.state = {
      floatBalance: 0,
      floatBalanceFetched: false,
      availableBalance: 0,
      maxPayoutBalance: 0,
      equityBalance: 0,
      maxPayoutBalanceFetched: false,
      currentMaxCharge: 0,
      currentFloatLimit: 0,
      maxCharge: 0,
      floatLimit: 0,
      spendingThisMonth: 0,
      budget: null,
      spendingThisMonthFetched: false,
      showRequestLimitsDialog: false,
      requestLimitsReason: ''
    };  
  }

  componentDidMount() {
    this.fetchAccountLedgerSummary();
    this.fetchAccountSpendingThisMonth();
  }

  fetchAccountLedgerSummary = () => {
    AccountLedgerSummaryFetch.fetch(this.props.accountId).toPromise()
    .then(alsf => {
      if (alsf.getaccountledgersummary) {
        let theEquityBalance = alsf.getaccountledgersummary.equityBalance;
        if (theEquityBalance < 0)
          theEquityBalance = 0;
        this.setState({floatBalance: alsf.getaccountledgersummary.floatBalanceForAuth, availableBalance: alsf.getaccountledgersummary.assetArAuthBalance, equityBalance: theEquityBalance, maxPayoutBalance: alsf.getaccountledgersummary.maxPayoutBalance, floatBalanceFetched: true, maxPayoutBalanceFetched: true});
      }
    })
    .catch(err => {
      //nothing to do....
    })
  }

  fetchAccountSpendingThisMonth = () => {
    AccountSpendingThisMonthFetch.fetch(this.props.accountId).toPromise()
    .then(astm => {
      if (astm.getaccountspendingthismonth2) {
        let stm = astm.getaccountspendingthismonth2.spentThisMonth;
        if (stm == null || stm < 0) {
          stm = 0;
        }

        let budget = astm.getaccountspendingthismonth2.budget;
        this.setState({spendingThisMonth: stm, budget: budget, spendingThisMonthFetched: true});
      }
    })
    .catch(err => {
      //nothing to do....
    })
  }

  showRequestLimitsDialog = (maxCharge, floatLimit) => {

    let setMaxCharge = maxCharge;
    let setFloatLimit = floatLimit;
    if (this.state.maxCharge > 0) {
      setMaxCharge = this.state.maxCharge;
    }
    if (this.state.floatLimit > 0) {
      setFloatLimit = this.state.floatLimit;
    }
    this.setState({showRequestLimitsDialog: true,
                   currentMaxCharge: maxCharge,
                   currentFloatLimit: floatLimit,
                   maxCharge: setMaxCharge, 
                   floatLimit: setFloatLimit});
  }

  sendLimitIncreaseRequest(accountId) {
    // For now, notification
    const { callPartnerApi } = this.props.auth;
    if (abEnvironment.isSegmentActive()) { window.analytics.track('Limit Increase Request'); }

    let theBody = 'You requested';

    if (this.state.maxCharge !== this.state.currentMaxCharge) {
      let reqBal = Number(this.state.maxCharge).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
      theBody = theBody + ' a max charge limit of ' + reqBal;
    }
    if (this.state.floatLimit !== this.state.currentFloatLimit) {
      let reqFloat = Number(this.state.floatLimit).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
      if (this.state.maxCharge !== this.state.currentMaxCharge) {
        theBody = theBody + ' and';
      }
      theBody = theBody + ' an outstanding balance limit of ' + reqFloat;
    }

    let aPjwt = abEnvironment.getPjwt();
    theBody = theBody + ' with this reason: ' + this.state.requestLimitsReason;

    let payload = {
      operation: "createNotification",
      params: {
        pJwt:             aPjwt,
        accountId:        accountId,
        notificationType: 'increase',
        severity:         'info',
        subject:          'Limit increase request',
        body:             theBody
      }
    }
    
    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(response => {
      this.setState({showRequestLimitsDialog: false, requestLimitsReason: ''});
    })
    .catch(error => {
      this.setState({showRequestLimitsDialog: false, requestLimitsReason: ''});
    });

  }

  render() {
      const classes = this.props.classes;

      let theTileClass = classes.dbTile;
      let theLpClass   = classes.lp1;
      if (this.props.narrow === true) {
        theTileClass = classes.dbTile2;
        theLpClass   = classes.lp2;
      }

      let limitOnly = false;
      if (this.props.limitOnly === 1) {
        limitOnly = true;
      }

      let showMaxCharge = false;
      if (this.props.showMaxCharge === undefined || this.props.showMaxCharge) {
        showMaxCharge = true;
      }

      let showTopUpStuff = false;
      if (this.props.useBudgets >= 1) {
        showTopUpStuff = true;
      }
        
      return (
          <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={DashboardLimitRequestQuery}
          variables={{accountId: this.props.accountId}}
          render={({error, props})=> {

            if (error) {

              return <div>{error.message}</div>

            } else if (props) {
              let percentBalanceUsed = 0;
              let floatBalanceDisplay = '';
              let floatLimitDisplay = '';
              if (this.state.floatBalanceFetched) {
                let theFloatBalance = this.state.floatBalance;
                if (theFloatBalance < 0) {
                  theFloatBalance = 0;
                }

                let theFloatLimit = this.props.floatLimit;
                if (theFloatLimit == null) {
                  theFloatLimit = props.accountTByAccountId.floatLimit;
                }

                let balanceUsed = 0;
                /*
                if (props.accountTByAccountId.floatLimit != 0) {
                  balanceUsed = theFloatBalance / props.accountTByAccountId.floatLimit;
                }
                */
                if (theFloatLimit !== 0) {
                  balanceUsed = theFloatBalance / theFloatLimit;
                }

                //since balance used is a decimal, multiply by 100 and round to nearest whole number
                balanceUsed = balanceUsed * 100;
                percentBalanceUsed = Math.round(balanceUsed);

                floatBalanceDisplay = Number(theFloatBalance).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                floatLimitDisplay = Number((theFloatLimit)).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
              }

              let spendingThisMonthDisplay = '';
              let budgetDisplay = '';

              let theBudget = null;
              if (this.props.budget != null) {
                theBudget = this.props.budget;
              }

              let budUsed = 0;

              if (this.state.spendingThisMonthFetched) {
                spendingThisMonthDisplay = Number(this.state.spendingThisMonth).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                if (theBudget === null && this.state.budget != null) {
                  theBudget = this.state.budget;
                }

                if (theBudget > 0) {
                  budUsed = this.state.spendingThisMonth / theBudget;
                  budUsed = budUsed * 100;
                  budUsed = Math.round(budUsed);
                }
              }

              if (theBudget != null) {
                budgetDisplay = Number(theBudget).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
              }

              // There are 3 use cases we are supporting:
              // 1. Reseller looking at own account (on My funding)
              // 2. Customer looking at own account (on My funding)
              // 3. Reseller looking at customer account
              //
              // Depending on which case it is, there will be different verbiage in the various chicklets
              //
              let balanceTitle = "Your balance";
              let balanceTt = "If you markup SaaS apps, bill your services through AppBind, or receive rebates from vendors, you will build a balance of fees collected on your behalf. You can also top up your balance from a funding source.";
              let availableBalanceTitle = "Your available balance";
              let availableBalanceTt = "Your balance may include funds that haven't settled yet, so your available balance indicates what is currently available to pay for subscriptions.";
              let spendingTitle = "This month's spending";
              let spendingTt = "This is the amount you've spent on subscriptions this month.";
              let maxChargeTitle = "Maximum charge"
              let maxChargeTt = "This is the maximum individual charge amount we'll authorize on any subscription virtual card.";
              let floatLimitTitle = "Float (" + percentBalanceUsed + "% of limit)";
              let floatLimitTt = "We provide a float for purchasing subscriptions.  This, plus your topup balance, is the amount available for purchasing subscriptions.  We track the current float for all subscriptions that you've provisioned.  Each individual charge typically clears within a few days, but if you provision a large number of subscriptions and are not funding a top up balance, you may need a larger limit."

              if (showTopUpStuff) {
                floatLimitTitle = "Overdraft (" + percentBalanceUsed + "% of limit)";
                floatLimitTt = "We may provide an overdraft float for purchasing subscriptions.  This, plus your topup balance, is the amount available for purchasing subscriptions.  We track the current overdraft float for all subscriptions that you've provisioned.  Each individual charge typically clears within a few days, but if you provision a large number of subscriptions and are not funding a top up balance, you may need a higher overdraft limit."
              }

              if (abEnvironment.getUserAttribute("a_aType") === "4") {
                // Set the customer messages
                balanceTitle = "Your balance";
                balanceTt = "When you topup your account, you'll have a positive balance in AppBind.";
                availableBalanceTitle = "Your available balance";
                availableBalanceTt = "Your balance may include funds that haven't settled yet, so your available balance indicates what is currently available to pay for subscriptions.";
                maxChargeTitle = "Maximum charge"
                maxChargeTt = "This is the maximum individual charge amount we'll authorize on any subscription virtual card.";
                floatLimitTitle = "Float (" + percentBalanceUsed + "% of limit)";
                floatLimitTt = "We provide a float for purchasing subscriptions.  This, plus your topup balance, is the amount available for purchasing subscriptions.  We track the current float for all of your subscriptions.  Each individual charge typically clears within a few days, but if you have a large number of subscriptions and are not funding a top up balance, you may need a larger limit."

                if (showTopUpStuff) {
                  floatLimitTitle = "Overdraft (" + percentBalanceUsed + "% of limit)";
                  floatLimitTt = "We may provide an overdraft float for purchasing subscriptions.  This, plus your topup balance, is the amount available for purchasing subscriptions.  We track the current overdraft float for all subscriptions that you've provisioned.  Each individual charge typically clears within a few days, but if you provision a large number of subscriptions and are not funding a top up balance, you may need a higher overdraft limit."
                }
  
              } else if (this.props.accountId !== abEnvironment.getUserAttribute("a_id")) {
                // Set the reseller view customer messages
                balanceTitle = "Balance";
                balanceTt = "When your customer adds funds to their account, they'll have a positive balance in AppBind.";
                availableBalanceTitle = "Available balance";
                availableBalanceTt = "Your customer's balance may include funds that haven't settled yet, so the available balance indicates what is currently available to pay for subscriptions.";
                spendingTitle = "This month's spending";
                spendingTt = "This is the amount your customer has spent on subscriptions this month.";
                maxChargeTitle = "Maximum charge"
                maxChargeTt = "This is the maximum individual charge amount we'll authorize on any subscription virtual card for this customer.";
                floatLimitTitle = "Float (" + percentBalanceUsed + "% of limit)";
                floatLimitTt = "We provide your customer with a float for purchasing subscriptions.  This, plus your customer's topup balance, is the amount available for purchasing subscriptions.  We track the current float for all subscriptions that you've provisioned for your customer.  Each individual charge typically clears within a few days, but if you provision a large number of subscriptions and your customer is not funding a top up balance, they may need a larger limit."

                if (showTopUpStuff) {
                  floatLimitTitle = "Overdraft (" + percentBalanceUsed + "% of limit)";
                  floatLimitTt = "We may provide your customer with an overdraft float for purchasing subscriptions.  This, plus your customer's topup balance, is the amount available for purchasing subscriptions.  We track the current overdraft float for all subscriptions that you've provisioned for your customer.  Each individual charge typically clears within a few days, but if you provision a large number of subscriptions and your customer is not funding a top up balance, they may need a higher overdraft limit."
                }
              }

              return (
                <React.Fragment>
                  <Grid container spacing={3} justifyContent="flex-start" style={{marginTop: 8}}>
                    <Grid item>
                      <Grid container spacing={3}>
                        {this.state.maxPayoutBalanceFetched && ! limitOnly &&
                          <Grid item>
                            <Paper className={theTileClass}>
                              <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                                <Grid item>
                                  <Typography variant="h6">
                                    <NumericFormat
                                      value={this.state.equityBalance}
                                      valueIsNumericString
                                      prefix={'$'} 
                                      displayType="text"
                                      decimalScale={2}
                                      fixedDecimalScale
                                      thousandSeparator/>
                                  </Typography>
                                </Grid>
                                <Grid item>
                                  <Grid container justifyContent="flex-start" alignItems="center" spacing={0}>
                                    <Grid>
                                      <Typography variant="body2" style={{marginTop: 2}}>{balanceTitle}</Typography>
                                    </Grid>
                                    <Grid item>
                                      <Tooltip placement='bottom' title={balanceTt}>
                                        <HelpOutline fontSize="small" style={{verticalAlign: "-9%", marginLeft: '4px'}}/>
                                      </Tooltip>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Paper>
                          </Grid>
                        }

                        {this.state.maxPayoutBalanceFetched && ! limitOnly &&
                          <Grid item>
                            <Paper className={theTileClass}>
                              <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                                <Grid item>
                                  <Typography variant="h6">
                                    <NumericFormat
                                      value={this.state.availableBalance}
                                      valueIsNumericString
                                      prefix={'$'} 
                                      displayType="text"
                                      decimalScale={2}
                                      fixedDecimalScale
                                      thousandSeparator/>
                                  </Typography>
                                </Grid>
                                <Grid item>
                                  <Grid container justifyContent="flex-start" alignItems="center" spacing={0}>
                                    <Grid>
                                      <Typography variant="body2" style={{marginTop: 2}}>{availableBalanceTitle}</Typography>
                                    </Grid>
                                    <Grid item>
                                      <Tooltip placement='bottom' title={availableBalanceTt}>
                                        <HelpOutline fontSize="small" style={{verticalAlign: "-9%", marginLeft: '4px'}}/>
                                      </Tooltip>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Paper>
                          </Grid>
                        }

                        { ! limitOnly && showMaxCharge &&
                        <Grid item> 
                          <Paper className={theTileClass}>
                            <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                              <Grid item>
                                <Typography variant="h6">
                                  <NumericFormat
                                    value={(this.props.maxCharge ? this.props.maxCharge : props.accountTByAccountId.maxCharge)}
                                    valueIsNumericString
                                    prefix={'$'} 
                                    displayType="text"
                                    decimalScale={2}
                                    fixedDecimalScale
                                    thousandSeparator/>
                                </Typography>
                              </Grid>
                              <Grid item>
                                <Grid container justifyContent="flex-start" alignItems="center" spacing={0}>
                                  <Grid item>
                                    <Typography variant="body2" style={{marginTop: 2}}>{maxChargeTitle}</Typography>
                                  </Grid>
                                  <Grid item>
                                    <Tooltip placement='bottom' title={maxChargeTt}>
                                      <HelpOutline fontSize="small" style={{verticalAlign: "-9%", marginLeft: '4px'}}/>
                                    </Tooltip>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>}

                        {this.state.spendingThisMonthFetched && (theBudget == null || theBudget <= 0) &&
                          <Grid item>
                            <Paper className={theTileClass}>
                              <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                                <Grid item>
                                  <Typography variant="h6">
                                    <NumericFormat
                                      value={this.state.spendingThisMonth}
                                      valueIsNumericString
                                      prefix={'$'} 
                                      displayType="text"
                                      decimalScale={2}
                                      fixedDecimalScale
                                      thousandSeparator/>
                                  </Typography>
                                </Grid>
                                <Grid item>
                                  <Grid container justifyContent="flex-start" alignItems="center" spacing={0}>
                                    <Grid>
                                      <Typography variant="body2" style={{marginTop: 2}}>{spendingTitle}</Typography>
                                    </Grid>
                                    <Grid item>
                                      <Tooltip placement='bottom' title={spendingTt}>
                                        <HelpOutline fontSize="small" style={{verticalAlign: "-9%", marginLeft: '4px'}}/>
                                      </Tooltip>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Paper>
                          </Grid>
                        }

                        {this.state.spendingThisMonthFetched && theBudget != null && theBudget > 0 &&
                          <Grid item>
                            <Paper className={theTileClass}>
                              <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                                <Grid item style={{marginBottom: '-3px'}}>
                                  <Typography variant="h6">{spendingThisMonthDisplay} / <sub>{budgetDisplay}</sub></Typography>
                                </Grid>
                                <Grid item>
                                  <Grid container justifyContent="flex-start" alignItems="center" spacing={0}>
                                    <Grid>
                                      <Typography variant="body2" align="center">{spendingTitle}</Typography>
                                    </Grid>
                                    <Grid item>
                                      <Tooltip placement='bottom' title={spendingTt}>
                                        <HelpOutline fontSize="small" style={{verticalAlign: "-9%", marginLeft: '4px'}}/>
                                      </Tooltip>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid>
                                  <LinearProgress variant="buffer" value={budUsed} className={theLpClass}
                                                  valueBuffer={100} color="secondary" />
                                </Grid>
                              </Grid>
                            </Paper>
                          </Grid>
                        }

                        {this.state.floatBalanceFetched &&
                        <Grid item>
                          <Paper className={theTileClass}>
                            <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                              <Grid item style={{marginBottom: '-3px'}}>
                                <Typography variant="h6">{floatBalanceDisplay} / <sub>{floatLimitDisplay}</sub></Typography>
                              </Grid>
                              <Grid item>
                                <Grid container justifyContent="flex-start" alignItems="center" spacing={0}>
                                  <Grid item>
                                    <Typography variant="body2" align="center">{floatLimitTitle}</Typography>
                                  </Grid>
                                  <Grid>
                                    <Tooltip placement='bottom' title={floatLimitTt}>
                                      <HelpOutline fontSize="small" style={{verticalAlign: "-9%", marginLeft: '4px'}}/>
                                    </Tooltip>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid>
                                <LinearProgress variant="buffer" value={percentBalanceUsed} className={theLpClass}
                                                valueBuffer={100} color="secondary" />
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                        }
                      </Grid>
                    </Grid>

                    {this.props.showRequestButton &&
                    <Grid item>
                      <Button color="primary"  variant="outlined" size="small" 
                              onClick={() => {this.showRequestLimitsDialog(props.accountTByAccountId.maxCharge, props.accountTByAccountId.floatLimit)}}>
                        Request higher limits
                      </Button> 
                    </Grid>
                    }
                  </Grid>

                  <DashboardRequestLimitDialog
                    open={this.state.showRequestLimitsDialog}
                    onClose={() => { this.setState({showRequestLimitsDialog:false});}}
                    onConfirm={() => { this.sendLimitIncreaseRequest(this.props.accountId)}}
                    onCancel={() => { this.setState({showRequestLimitsDialog:false});}}
                    reason={this.state.requestLimitsReason}
                    title="Request higher limits"
                    cancelBtn="Cancel"
                    okBtn="Send Request">
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          { showTopUpStuff &&
                          <Typography variant="body1">
                            For your protection and ours, we set a limit on individual charges.  We also set a limit on the overdraft float
                            balance across all subscriptions.  To request a higher limit, please indicate requested limit amounts, and enter
                            your reason for requesting an increase.
                          </Typography>}
                          { ! showTopUpStuff &&
                          <Typography variant="body1">
                            For your protection and ours, we set a limit on individual charges.  We also set a limit on the total outstanding
                            balance across all subscriptions.  To request a higher limit, please indicate requested limit amounts, and enter
                            your reason for requesting an increase.
                          </Typography>}
                        </Grid>
                        <Grid item>
                          <CurrencyTextField 
                            id="max-charge" label="Maximum charge"
                            value={this.state.maxCharge}
                            onChange={ (e) => this.setState({ maxCharge: e.target.value }) }
                            showErrMsg={true}
                            allowNegative={false}
                            minValue={0}
                            minEnterValue={0}
                            textAlign="right"
                          />
                        </Grid>
                        <Grid item>
                          { showTopUpStuff &&
                          <CurrencyTextField 
                            id="balance-limit" label="Overdraft limit"
                            value={this.state.floatLimit}
                            onChange={ (e) => this.setState({ floatLimit: e.target.value }) }
                            showErrMsg={true}
                            allowNegative={false}
                            minValue={0}
                            minEnterValue={0}
                            textAlign="right"
                          />}
                          { ! showTopUpStuff &&
                          <CurrencyTextField 
                            id="balance-limit" label="Float limit"
                            value={this.state.floatLimit}
                            onChange={ (e) => this.setState({ floatLimit: e.target.value }) }
                            showErrMsg={true}
                            allowNegative={false}
                            minValue={0}
                            minEnterValue={0}
                            textAlign="right"
                          />}
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            id="landing-text" label="Reason for increase" 
                            value={this.state.requestLimitsReason}
                            fullWidth
                            multiline
                            onChange={(e) => this.setState({ requestLimitsReason: e.target.value })}
                            inputProps={{ maxLength: 2048 }} />
                        </Grid>
                      </Grid>
                  </DashboardRequestLimitDialog>
              </React.Fragment>
              );
            }
              
            }}
          />
    );
  }
}

export default withStyles(styleSheet)(DashboardLimitRequest);